/* Browser auth state. No Entra, application, or refresh token is persisted. */

import { setSentryUser } from "../services/sentry.js";

let authConfig = null;
let currentUser = null;
let csrfToken = "";
let legacyApiKey = "";
let authStateGeneration = 0;

const LEGACY_SESSION_KEY = "novatime_legacy_api_key";

export function initializeLegacyCredentialMigration() {
  const oldKey = localStorage.getItem("api_key") || "";
  legacyApiKey = sessionStorage.getItem(LEGACY_SESSION_KEY) || oldKey;
  localStorage.removeItem("api_key");
  if (legacyApiKey) sessionStorage.setItem(LEGACY_SESSION_KEY, legacyApiKey);
  authStateGeneration += 1;
}

export function setAuthConfig(value) {
  authConfig = value || null;
}

export function getAuthConfig() {
  return authConfig;
}

export function setWebSession(session) {
  currentUser = session?.user || null;
  setSentryUser(currentUser?.id || null);
  csrfToken = session?.csrf_token || "";
  legacyApiKey = "";
  sessionStorage.removeItem(LEGACY_SESSION_KEY);
  authStateGeneration += 1;
}

export function getCurrentUser() {
  return currentUser;
}

export function setLegacyApiKey(value) {
  legacyApiKey = String(value || "").trim();
  currentUser = null;
  csrfToken = "";
  if (legacyApiKey) sessionStorage.setItem(LEGACY_SESSION_KEY, legacyApiKey);
  else sessionStorage.removeItem(LEGACY_SESSION_KEY);
  authStateGeneration += 1;
}

export function getLegacyApiKey() {
  return legacyApiKey;
}

export function clearLegacyApiKey() {
  legacyApiKey = "";
  sessionStorage.removeItem(LEGACY_SESSION_KEY);
  authStateGeneration += 1;
}

export function clearWebSession() {
  currentUser = null;
  setSentryUser(null);
  csrfToken = "";
  authStateGeneration += 1;
}

export function getAuthTransportSnapshot() {
  return {
    generation: authStateGeneration,
    credentialMethod: legacyApiKey ? "legacy" : "web",
  };
}

export function isCurrentAuthTransport(snapshot) {
  return Boolean(snapshot) && snapshot.generation === authStateGeneration;
}

export function getRequestAuthHeaders(method = "GET") {
  const headers = {};
  if (legacyApiKey) headers["X-Api-Key"] = legacyApiKey;
  if (
    csrfToken &&
    ["POST", "PUT", "PATCH", "DELETE"].includes(String(method).toUpperCase())
  ) {
    headers["X-CSRF-Token"] = csrfToken;
  }
  return headers;
}

export function hasUsableAuth() {
  return Boolean(currentUser || legacyApiKey) || authConfig?.mode === "disabled";
}
